// extracted by mini-css-extract-plugin
export default {"wrapper":"FluidLayout_wrapper__qIJKF","content":"FluidLayout_content__OIxio"};